module.exports = __webpack_public_path__ + "static/media/ico-predefinido-sel.f525613b.svg";